import React, {useMemo} from 'react';
import History from '@di-shared/features/history';
import {useSearchParams} from 'react-router-dom';
import {getYYYYMMFormat} from '@di-shared/api/di/utils';

const TAB = 'tab';
const MONTH = 'month';

export enum HistoryTab {
  DRIVING_INFO = 'driving-info',
  EV_ENERGY_USAGE = 'ev-energy-usage',
}

interface HistoryPageProps {
  vin: string;
}

export default function HistoryPage({vin}: HistoryPageProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Tab
  const historyTab = useMemo(() => {
    return searchParams.get(TAB) || HistoryTab.DRIVING_INFO;
  }, [searchParams]);

  function changeTab(tabType: HistoryTab) {
    searchParams.set(TAB, tabType.toString());
    setSearchParams(searchParams, {replace: true});
  }

  // Month
  const historyMonth = useMemo(() => {
    return searchParams.get(MONTH) || getYYYYMMFormat(new Date());
  }, [searchParams]);

  function changeMonth(date: Date) {
    searchParams.set(MONTH, getYYYYMMFormat(date));
    setSearchParams(searchParams, {replace: true});
  }

  return (
    <History
      vin={vin}
      tab={historyTab}
      changeTab={changeTab}
      month={historyMonth}
      changeMonth={changeMonth}
    />
  );
}
